<template>
  <div class="container-fluid py-4">
    <div class="row">
      <div class="col-12">
        <div class="card my-4">
          <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
            <div
              class="bg-gradient-success shadow-success border-radius-lg pt-4 pb-3"
            >
              <h6 class="text-white text-capitalize ps-3">
                {{ isEdit ? "編輯折價券" : "新增折價券" }}
              </h6>
            </div>
          </div>
          <div class="card-body">
            <form @submit.prevent="submitForm">
              <div class="row">
                <div class="col-md-6 mb-3">
                  <label class="form-label">折扣碼 (Code)</label>
                  <input
                    type="text"
                    class="form-control border p-2"
                    v-model="form.code"
                    required
                    :disabled="isEdit"
                  />
                </div>
                <div class="col-md-6 mb-3">
                  <div class="form-check form-switch ps-0 mt-4">
                    <input
                      class="form-check-input ms-auto"
                      type="checkbox"
                      id="isActive"
                      v-model="form.is_active"
                    />
                    <label
                      class="form-check-label text-body ms-3 text-truncate w-80 mb-0"
                      for="isActive"
                      >啟用狀態</label
                    >
                  </div>
                </div>

                <div class="col-md-6 mb-3">
                  <label class="form-label">類型</label>
                  <select class="form-select border p-2" v-model="form.type">
                    <option value="fixed">定額金額 ($)</option>
                    <option value="percent">百分比 (%)</option>
                  </select>
                </div>

                <div class="col-md-6 mb-3">
                  <label class="form-label"
                    >數值 ({{
                      form.type === "fixed" ? "金額" : "百分比"
                    }})</label
                  >
                  <input
                    type="number"
                    step="0.01"
                    class="form-control border p-2"
                    v-model="form.value"
                    required
                  />
                </div>

                <div class="col-md-6 mb-3">
                  <label class="form-label">最低消費金額 (選填)</label>
                  <input
                    type="number"
                    step="0.01"
                    class="form-control border p-2"
                    v-model="form.min_spend"
                  />
                </div>

                <div class="col-md-6 mb-3">
                  <label class="form-label">使用次數限制 (選填)</label>
                  <input
                    type="number"
                    class="form-control border p-2"
                    v-model="form.usage_limit"
                  />
                </div>

                <div class="col-md-6 mb-3">
                  <label class="form-label">開始時間</label>
                  <input
                    type="datetime-local"
                    class="form-control border p-2"
                    v-model="form.start_at"
                  />
                </div>

                <div class="col-md-6 mb-3">
                  <label class="form-label">結束時間</label>
                  <input
                    type="datetime-local"
                    class="form-control border p-2"
                    v-model="form.end_at"
                  />
                </div>

                <div class="col-12 mb-3">
                  <label class="form-label">備註 (內部顯示)</label>
                  <textarea
                    class="form-control border p-2"
                    v-model="form.notes"
                    rows="3"
                  ></textarea>
                </div>
              </div>

              <div class="d-flex justify-content-end mt-4">
                <router-link to="/marketing/coupons" class="btn btn-light me-2"
                  >取消</router-link
                >
                <button type="submit" class="btn btn-success">儲存</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/utils/request";
import Swal from "sweetalert2";

export default {
  name: "CouponForm",
  data() {
    return {
      isEdit: false,
      form: {
        code: "",
        type: "fixed",
        value: 0,
        min_spend: null,
        usage_limit: null,
        start_at: null,
        end_at: null,
        is_active: true,
        notes: "",
      },
      orders: [],
    };
  },
  async mounted() {
    const id = this.$route.params.id;
    if (id) {
      this.isEdit = true;
      await this.fetchCoupon(id);
      await this.fetchCoupon(id);
    }
  },
  methods: {
    async fetchCoupon(id) {
      try {
        const response = await axios.get(`/api/admin/coupons/${id}`);
        // Date formatting for input type="datetime-local" if needed,
        // usually needs YYYY-MM-DDTHH:mm format
        this.form = response.data;
        // Transform dates
        if (this.form.start_at)
          this.form.start_at = this.form.start_at.slice(0, 16);
        if (this.form.end_at) this.form.end_at = this.form.end_at.slice(0, 16);
      } catch (error) {
        console.error("Error fetching coupon:", error);
      }
    },
    async submitForm() {
      try {
        const payload = { ...this.form };
        // Empty strings to null
        if (!payload.min_spend) payload.min_spend = null;
        if (!payload.usage_limit) payload.usage_limit = null;

        if (this.isEdit) {
          await axios.put(`/api/admin/coupons/${this.form.id}`, payload);
          Swal.fire("成功", "折價券已更新", "success");
        } else {
          await axios.post("/api/admin/coupons", payload);
          Swal.fire("成功", "折價券已建立", "success");
          this.$router.push("/marketing/coupons");
        }
      } catch (error) {
        console.error(error);
        const msg = error.response?.data?.message || "操作失敗";
        Swal.fire("錯誤", msg, "error");
      }
    },
  },
};
</script>
